import React from 'react';
import './ContactUsPage.css';
import Footer from './footer';

export default function ContactUs() {
  return (
    <section className="contact-section rtl" style={{ cursor: "url('/images/shell.png'), auto" }}>


      {/* Hero */}
      <div className="contact-hero">

      </div>


      {/* Main content */}
      <div className="contact-container">
        {/* Form */}
        <form className="contact-form">
          <div className="form-group">
            <input type="text" id="name" required placeholder=" " />
            <label htmlFor="name">نام کامل</label>
          </div>
          <div className="form-group">
            <input type="email" id="email" required placeholder=" " />
            <label htmlFor="email">ایمیل</label>
          </div>
          <div className="form-group">
            <textarea id="message" rows="5" required placeholder=" "></textarea>
            <label htmlFor="message">پیام شما</label>
          </div>
          <button type="submit">ارسال پیام</button>
        </form>

        {/* Info */}
        <div className="contact-info">
          <h2>راه‌های ارتباطی</h2>
          <ul>
            <li><strong> تلفن ثابت: </strong> ۴۴۲۸۷۰۱۸۶-۰۲۱</li>
            <li><strong> ایمیل:</strong> info@goharesadaf.ir</li>
            <li><strong> آدرس:</strong>  تهران، خیابان ولیعصر، نبش کوچه بالاور، مرکز خدمات توسعه بازار پارک علم و فناوری دانشگاه امیرکبیر</li>
          </ul>

          <div className="social">
            <h3>ما را دنبال کنید:</h3>
            <div className="icons">
              <a href="#"><i className="fab fa-telegram"></i></a>
              <a href="#"><i className="fab fa-whatsapp"></i></a>
              <a href="#"><i className="fab fa-linkedin"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>

            </div>
          </div>
        </div>
        
            {/* Google Map */}
        <div className="map-container">
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d809.8581100254081!2d51.33739210462464!3d35.71558190648691!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDQyJzU1LjUiTiA1McKwMjAnMTQuNSJF!5e0!3m2!1sen!2s!4v1754723850669!5m2!1sen!2s" // paste your full Google Maps iframe src here
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Business Location"
        ></iframe>
        </div>

      </div>
      {/* Footer */}
      <Footer />

    </section>
  );
}
